import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { setClass, useViewModel } from '@utils';
import { isMobile } from 'react-device-detect';
import { emailValidator } from '@helpers';
import { ProfileViewModel } from '@views';
import { Button } from '@components';
import { Input } from '../input';
import { EmailField } from './EmailField';
import '../../styles/components/emailsList.scss';

export const EmailsList: FC = observer(() => {
  const profileViewModel = useViewModel(ProfileViewModel);
  const onChange = (value: string) => profileViewModel.editNewEmail(value);
  useEffect(() => {
    profileViewModel.initEmails();
  }, []);

  return (
    <div>
      <EmailField email={profileViewModel.profileInfo.corporateEmail} isVerified />

      {profileViewModel.mutableEmails.map((emailObj) => (
        <EmailField
          resend={profileViewModel.resendConfirmation}
          key={emailObj.email}
          email={emailObj.email}
          isVerified={emailObj.isVerified}
          onDelete={profileViewModel.deleteEmail}
        />
      ))}

      <div>
        {profileViewModel.isCreateNewEmail
          ? (
            <div className="new-email-field">
              <div className={setClass('email-field', isMobile && 'mobile')}>
                <Input
                  variant="square"
                  placeholder="Введите Email"
                  value={profileViewModel.newEmail}
                  onChange={onChange}
                />
              </div>
              <div className="button-area">
                <Button
                  className={setClass('outlined small', isMobile && 'mobile-button')}
                  onClick={profileViewModel.switchNewEmailFieldVisibility}
                  title="Отмена"
                />
                <Button
                  className={setClass('small', isMobile && 'mobile-button')}
                  onClick={profileViewModel.setNewEmail}
                  disabled={!emailValidator(profileViewModel.newEmail)}
                  title="Сохранить"
                />
              </div>
            </div>
          )
          : (
            <div className="add-email-button-area">
              <Button
                title="Добавить почту"
                className={setClass(isMobile ? 'mobile-button medium' : 'medium-long')}
                onClick={profileViewModel.switchNewEmailFieldVisibility}
              />
            </div>
          )}
      </div>
    </div>
  );
});
